export default class InfoProductEntity {
    constructor (data) {
        return data;
    }

}